import React, { useEffect, useState } from "react";
import {
  useEditDocumentMutation,
  useGetSingleDocumentIdQuery,
} from "../../../../features/api/admin/gestisciDocumentiApi";
import CoreSpinner from "../CoreSpinner/CoreSpinner";
import { useSelector } from "react-redux";
import { t } from "i18next";
import CoreButton from "../CoreButton/CoreButton";
import { toast } from "react-toastify";
import {
  convertEmojiToText,
  convertTextToEmoji,
} from "../../../../utils/constants/emojiMap";

const DocComposition = ({ document }) => {
  const [extractedDocument, setExtractedDocument] = useState();
  const [editExtDoc, setEditExtDoc] = useState();
  const colorPrimary = useSelector((state) => state.app.primaryColor);

  const { data: singleDoc, isLoading } = useGetSingleDocumentIdQuery(document, {
    skip: !document,
  });

  const [editDocument, { isLoading: isEditLoading }] =
    useEditDocumentMutation();

  useEffect(() => {
    if (singleDoc && singleDoc?.Data?.extractedDocument) {
      try {
        setExtractedDocument(singleDoc?.Data?.extractedDocument);
      } catch (error) {
        console.error("Errore:", error);
        return null;
      }
    }
  }, [singleDoc]);

  const handleInputChange = (txt) => {
    setEditExtDoc(txt);
  };

  const formatTextToHTML = (text) => {
    return text.split("\n").map((line, index) => {
      if (line.trim() === "") return <br key={index} />;
      const formattedLine = line
        .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")
        .replace(/\\n/g, "<br>")
        .replace(/:-\*/g, " ");

      const emoji = convertTextToEmoji(formattedLine);

      return (
        <div
          className="p-4"
          contentEditable
          key={index}
          dangerouslySetInnerHTML={{ __html: emoji }}
          onInput={(e) => handleInputChange(e.currentTarget.innerHTML)}
        />
      );
    });
  };

  const handleEdit = () => {
    const id = toast.loading(t("Saving..."), {
      type: "info",
    });
    const bodyData = {
      id: singleDoc?.Data?.id,
      mainCategoryId: singleDoc?.Data?.mainCategoryId,
      categoryId: singleDoc?.Data?.categoryId,
      name: singleDoc?.Data?.name,
      extractedDocument: convertEmojiToText(editExtDoc),
    };

    editDocument(bodyData)
      .unwrap()
      .then((data) => {
        if (data.Result !== 1)
          return toast.update(id, {
            render: data.Exception || t("DocNotEdited"),
            type: "error",
            autoClose: 1500,
            isLoading: false,
          });
        toast.update(id, {
          render: t("DocEdited"),
          type: "success",
          autoClose: 1500,
          isLoading: false,
        });
      })
      .catch(() => {
        toast.update(id, {
          render: t("DocNotEdited"),
          type: "error",
          autoClose: 1500,
          isLoading: false,
        });
      });
  };

  if (isLoading) {
    return <CoreSpinner />;
  }

  return (
    <>
      {document && extractedDocument ? (
        <div className="w-full overflow-auto p-4 mb-4">
          <>
            <h2 style={{ color: colorPrimary }} className="text-center">
              {t("GeneratedIADocument")}
            </h2>
            <div>{formatTextToHTML(extractedDocument)}</div>

            <div className="w-full flex justify-center pt-6">
              <CoreButton
                className=" btn-round"
                disabled={!editExtDoc || isEditLoading}
                testo={t("Save")}
                onClick={handleEdit}
              />
            </div>
          </>
        </div>
      ) : (
        <div className="w-full h-2/3  flex flex-col justify-center text-center">
          <h3 className="text-2xl"> {t("GeneratedIADocument")}</h3>
          <p>{t("ErrorRetrievingCategoriesData")}</p>
        </div>
      )}
    </>
  );
};

export default DocComposition;
